export const versionMismatchAlert = async () => {
  alert("A new version is available. Please click OK to refresh.");
  window.location.reload(); // Refresh the page
};
